import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import Hidden from "@material-ui/core/Hidden";
import Divider from "@material-ui/core/Divider";
import MenuIcon from "@material-ui/icons/Menu";
import Icon from "@material-ui/core/Icon";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";

import ActionRow from "./ActionRow";
import NoticePanel from "./NoticePanel/NoticePanel";
import ResultPanel from "./ResultPanel/ResultPanel";
import AssignmentPanel from "./Assignment/AssignmentPanel";
import QuestionPanel from "./QuestionPaper/QuestionPanel";
import NotesPanel from "./Notes/NotesPanel";
import Newsfeed from "./Newsfeed/Newsfeed";
import GalleryPanel from "./GalleryPanel/GalleryPanel";
import StudentPanel from "./StudentsPanel/StudentPanel";

import uploadGif from "../../assets/Images/uploading.gif";
import axios from "axios";
import AES from "crypto-js/aes";
import CryptoJS from "crypto-js";
import { getCookie } from "../../components/Utils/Cookie";


// ----------------------- Styles -----------------------
const StyledTableCell = withStyles((theme) => ({
  head: {
      backgroundColor: "#212121",
      color: theme.palette.common.white,
  },
  body: { fontSize: 14 }
}))(TableCell);

const drawerWidth = 240;

const styles = (theme) => ({
  root: {
      flexGrow: 1,
      position: "relative",
      display: "inline-flex",
      width: "100%",
  },
  appBar: {
      background: "#212121",
      position: "absolute",
      marginLeft: drawerWidth,
      [theme.breakpoints.up("md")]: { zIndex: theme.zIndex.drawer + 1 }
  },
  navIconHide: {
      [theme.breakpoints.up("md")]: { display: "none" }
  },
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
      width: drawerWidth,
      [theme.breakpoints.up("md")]: { position: "relative" }
  },
  content: {
      textAlign: "left",
      flexGrow: 1,
      padding: 20,
      marginTop: 30,
      backgroundColor: theme.palette.background.default
  },
  listMain: {
      paddingLeft: 20,
      cursor: "pointer",
      display: "flex",
      alignItems: "center"
  },
  listMar: {
      marginRight: 20,
      position: "relative",
      top: 6,
  }
});


// =========================================================
//                     COMPONENT START
// =========================================================
class ResponsiveDrawer extends React.Component {

  constructor(props){
    super(props);

    this.state = {
      mobileOpen:false,
      adminData:null,
      showDiv:<img src={uploadGif} alt="loading" style={{marginTop:"60px",marginLeft:"42%"}}/>
    };

    // Bind functions
    this.getAddAdminData = this.getAddAdminData.bind(this);
    this.hanldeNoticeBoard = this.hanldeNoticeBoard.bind(this);
    this.handleResultBoard = this.handleResultBoard.bind(this);
    this.handleAssignment = this.handleAssignment.bind(this);
    this.handleQuestion = this.handleQuestion.bind(this);
    this.handleNotes = this.handleNotes.bind(this);
    this.handleNewsfeed = this.handleNewsfeed.bind(this);
    this.handleGallery = this.handleGallery.bind(this);
    this.handleMembers = this.handleMembers.bind(this);
  }

  
  // -------------------- On Load Check Access --------------------
  componentDidMount(){
    let dec = AES.decrypt(getCookie("_RSPTYPE"),this.props.check.state.publicKey);
    dec = dec.toString(CryptoJS.enc.Utf8);

    if(dec==="admin"){ this.getAddAdminData(); }
    else{
      console.log("NOT ADMIN");
      this.props.history.push("/login?rdr=adminpanel");
    }
  }


  // -------------------- Fetch Admin Permissions --------------------
  getAddAdminData(){
    (async()=>{
      while(!this.props.check.state.accessToken){
        await new Promise(r=>setTimeout(r,300));
      }

      const config = {
        withCredentials:true,
        headers:{
          "Content-Type":"application/json",
          Authorization:`Bearer ${this.props.check.state.accessToken}`
        }
      };

      axios.post("https://recstudentportal.com/api/v1/getAdminDetails.php",
        {key:"cmVhY3RBcHBQb3J0YWwyNjc="}, config
      )
      .then(res=>{
        this.setState({ adminData:JSON.parse(res.data) });
        this.setDashboard(res.data);
      })
      .catch(e=>{
        console.log("ERROR",e);
        this.props.history.push("/login?rdr=adminpanel");
      });
    })();
  }


  // -------------------- Load Permission Table --------------------
  setDashboard(data){
    let permissions=[
      "notice","result","assignment","previous_questions","delete_post",
      "notes","gallery","show_users","recomBook"
    ];

    let titles=[
      "Notice","Results","Assignment","Question Paper","Newsfeed",
      "Notes","Gallery","Members","Books"
    ];

    data = JSON.parse(data);
    let rows = permissions.map((p,i)=>(
      <ActionRow key={i} number={i+1} actionName={titles[i]} icon={data[p]==="1"?"check":"clear"}/>
    ));

    this.setState({
      showDiv:(
        <>
          <div className={this.props.classes.toolbar}/>
          <Typography variant="h5">Your access permissions:</Typography>
          <br/>
          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <StyledTableCell align="center">#</StyledTableCell>
                  <StyledTableCell align="center">Permission</StyledTableCell>
                  <StyledTableCell align="center">Allowed</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>{rows}</TableBody>
            </Table>
          </TableContainer>
        </>
      )
    });
  }


  // -------------------- All Admin Panel Navigation --------------------
  hanldeNoticeBoard(){ this.loadPanel("notice",<NoticePanel container={this.props.check.state}/>); }
  handleResultBoard(){ this.loadPanel("result",<ResultPanel container={this.props.check.state}/>); }
  handleAssignment(){ this.loadPanel("assignment",<AssignmentPanel container={this.props.check.state}/>); }
  handleQuestion(){ this.loadPanel("previous_questions",<QuestionPanel container={this.props.check.state}/>); }
  handleNotes(){ this.loadPanel("notes",<NotesPanel container={this.props.check.state}/>); }
  handleNewsfeed(){ this.loadPanel("delete_post",<Newsfeed container={this.props.check.state}/>); }
  handleGallery(){ this.loadPanel("gallery",<GalleryPanel container={this.props.check.state}/>); }
  handleMembers(){ this.loadPanel("show_users",<StudentPanel container={this.props.check.state}/>); }


  loadPanel(permission,component){
    if(this.state.adminData[permission]==="1") this.setState({showDiv:component});
    else this.setState({showDiv:<h5 style={{margin:"60px"}}>You are not allowed.</h5>});
    this.handleDrawerToggle();
  }


  handleDrawerToggle = ()=> this.setState(s=>({mobileOpen:!s.mobileOpen}));


  // -------------------- UI Rendering --------------------
  render(){
    const {classes,theme}=this.props;

    const drawer=(
      <div>
        <div className={classes.toolbar}/>
        <Divider/>
        
        <List className={classes.listMain} onClick={this.hanldeNoticeBoard}><Icon className={classes.listMar}>announcement</Icon>Notice</List><Divider/>
        <List className={classes.listMain} onClick={this.handleResultBoard}><Icon className={classes.listMar}>done</Icon>Results</List><Divider/>
        <List className={classes.listMain} onClick={this.handleAssignment}><Icon className={classes.listMar}>assignment</Icon>Assignment</List><Divider/>
        <List className={classes.listMain} onClick={this.handleQuestion}><Icon className={classes.listMar}>help</Icon>Question Paper</List><Divider/>
        <List className={classes.listMain} onClick={this.handleNewsfeed}><Icon className={classes.listMar}>favorite</Icon>Newsfeed</List><Divider/>
        <List className={classes.listMain} onClick={this.handleNotes}><Icon className={classes.listMar}>note</Icon>Notes</List><Divider/>
        <List className={classes.listMain} onClick={this.handleGallery}><Icon className={classes.listMar}>photolibrary</Icon>Gallery</List><Divider/>
        <List className={classes.listMain} onClick={this.handleMembers}><Icon className={classes.listMar}>person</Icon>Members</List><Divider/>
        <List className={classes.listMain}><Icon className={classes.listMar}>book</Icon>Books</List><Divider/>

      </div>
    );


    return (
      <div className={classes.root}>

        {/* Top Appbar */}
        <AppBar position="absolute" className={classes.appBar}>
          <Toolbar>
            <IconButton color="inherit" onClick={this.handleDrawerToggle} className={classes.navIconHide}>
              <MenuIcon/>
            </IconButton>
            <Typography variant="h6" noWrap>
              Admin Panel :: REC Student Portal
            </Typography>
          </Toolbar>
        </AppBar>


        {/* Mobile Drawer */}
        <Hidden mdUp>
          <Drawer variant="temporary" anchor={theme.direction==="rtl"?"right":"left"} 
            open={this.state.mobileOpen} onClose={this.handleDrawerToggle}
            classes={{paper:classes.drawerPaper}} ModalProps={{keepMounted:true}}>
            {drawer}
          </Drawer>
        </Hidden>

        {/* Desktop Drawer */}
        <Hidden smDown implementation="css">
          <Drawer variant="permanent" open classes={{paper:classes.drawerPaper}}>
            {drawer}
          </Drawer>
        </Hidden>

        {/* DISPLAY CONTENT */}
        <main className={classes.content}>
          {this.state.showDiv}
        </main>

      </div>
    );
  }
}

export default withStyles(styles,{withTheme:true})(ResponsiveDrawer);
